var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"googleMap",staticClass:"GoogleMap",style:(("height:" + _vm.height + "px;width:" + _vm.width + "px;")),attrs:{"id":_vm.id,"heatmapData":_vm.heatmap}})}
var staticRenderFns = []

export { render, staticRenderFns }